// src/components/RadarLoadingOverlay.tsx
import React, { useEffect, useState } from "react";
import "./radarLoadingOverlay.css";

type RadarLoadingOverlayProps = {
  visible: boolean;
};

const MENSAGENS = [
  "Buscando oportunidades para você...",
  "Analisando empreendimentos compatíveis...",
  "Verificando períodos disponíveis...",
  "Consultando nossa base de proprietários...",
  "Quase lá, finalizando sua análise..."
];

export const RadarLoadingOverlay: React.FC<RadarLoadingOverlayProps> = ({
  visible,
}) => {
  const [mensagemIndex, setMensagemIndex] = useState(0);

  useEffect(() => {
    if (!visible) return;

    setMensagemIndex(0);
    const interval = setInterval(() => {
      setMensagemIndex((prev) => (prev + 1) % MENSAGENS.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="radar-overlay">
      <div className="radar-box">
        <div className="radar">
          <div className="radar-circle circle-outer"></div>
          <div className="radar-circle circle-middle"></div>
          <div className="radar-circle circle-inner"></div>
          <div className="radar-center-dot"></div>
          <div className="radar-sweep"></div>
        </div>

        <div className="radar-text">
          <h3>Procurando oportunidades…</h3>
          <p>{MENSAGENS[mensagemIndex]}</p>
        </div>
      </div>
    </div>
  );
};
